import { type LogPanelState } from "@/shared/state/visualization";

import { type PanelSettingsSidebarProps } from "../../sidebarContext";
import { BasePanelSettings } from "../BasePanelSettings";
import { SettingsSection } from "../SettingsSection";
import styles from "../SettingsSection.module.css";
import { Spotlight } from "../Spotlight";

import { AddColumn } from "./AddColumn";
import { Columns } from "./Columns";

export interface LogPanelSettingsSidebarProps
  extends PanelSettingsSidebarProps {
  field?: "Columns";
}

interface LogPanelSettingsProps extends LogPanelSettingsSidebarProps {
  state: LogPanelState;
}

export function LogPanelSettings({
  field,
  spotlightKey,
  state,
}: LogPanelSettingsProps) {
  return (
    <BasePanelSettings state={state}>
      <SettingsSection title="Columns">
        <Columns panelId={state.id} columns={state.data} />
        <Spotlight
          className={styles.settingContainer}
          spotlightKey={field === "Columns" ? spotlightKey : undefined}
        >
          <AddColumn state={state} />
        </Spotlight>
      </SettingsSection>
    </BasePanelSettings>
  );
}
